module.exports = __webpack_public_path__ + "static/media/open source2.5b7b7bc4.jpg";